import { SET_OPEN_ACCOUNTS, SET_KPI_STATISTICS, SET_DASHBOARD_STATISTICS } from "../actions/reports";

export default (state = {}, action) => {
    switch (action.type) {
        case SET_OPEN_ACCOUNTS: {
            return { ...state, openAccounts: action.data }
        }
        case SET_KPI_STATISTICS: {
            return { ...state, kpiStatistics: action.data }
        }
        case SET_DASHBOARD_STATISTICS: {
            return { ...state, dashboardStatistics: action.data }
        }
        default:
            return state;
    }
};
